"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "23", height: "21", viewBox: "0 0 23 21", className: "Icon nav-antenna", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M6.781 2.451a.677.677 0 0 0-.955 0c-2.92 2.922-2.92 7.676 0 10.597a.673.673 0 0 0 .955.001.675.675 0 0 0 0-.955 6.149 6.149 0 0 1 0-8.688.675.675 0 0 0 0-.955m-2.838-.973a.675.675 0 1 0-.955-.955c-3.984 3.985-3.984 10.469 0 14.454a.676.676 0 0 0 .955-.955c-3.459-3.459-3.459-9.086 0-12.544M19.262.523a.675.675 0 1 0-.955.955c3.459 3.459 3.459 9.086 0 12.544a.675.675 0 1 0 .955.955c3.984-3.985 3.984-10.47 0-14.454m-3.793 1.929a.674.674 0 0 0 0 .954 6.152 6.152 0 0 1 0 8.689.674.674 0 0 0 .477 1.15.673.673 0 0 0 .478-.196c2.92-2.922 2.92-7.676 0-10.597a.676.676 0 0 0-.955 0z" }),
            _react2.default.createElement("path", { d: "M11.125 10.49a2.743 2.743 0 0 1-2.741-2.74 2.743 2.743 0 0 1 2.741-2.74 2.743 2.743 0 0 1 2.741 2.74 2.743 2.743 0 0 1-2.741 2.74zm.923 8.647a.452.452 0 0 1-.446.445h-.954a.452.452 0 0 1-.446-.445v-7.41c.298.069.605.114.923.114.318 0 .625-.045.923-.114v7.41zm-.923-15.478a4.09 4.09 0 0 0-2.272 7.49v7.988a1.8 1.8 0 0 0 1.795 1.795h.954a1.8 1.8 0 0 0 1.795-1.795V11.15a4.09 4.09 0 0 0-2.272-7.491z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/nav-antenna.js
// module id = 1815
// module chunks = 0